import { type FilterItem } from 'widgets/FilterEditor/model'

export const AutomationLogExecutionStatusKeys = new Set(['automation_log_steps.status'])

export const isAutomationLogExecutionStatusWidget = (filterItem: FilterItem) =>
  AutomationLogExecutionStatusKeys.has(filterItem.key)
